/* NAD Hair — Science Ingredients
   - Scroll-snap carousel with arrow controls
   - Touch/trackpad scroll works even without arrows
*/

(function () {
  function init(root) {
    const track = root.querySelector(".nhsi__track");
    if (!track) return;

    const btnPrev = root.querySelector("[data-nhsi-prev]");
    const btnNext = root.querySelector("[data-nhsi-next]");

    function hasArrows() {
      return !!(btnPrev && btnNext);
    }

    function getStep() {
      const slide = track.querySelector(".nhsi__slide");
      if (!slide) return Math.max(320, track.clientWidth * 0.9);

      const rect = slide.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;

      return rect.width + gap;
    }

    function updateButtons() {
      if (!hasArrows()) return;

      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
      const x = track.scrollLeft;

      btnPrev.disabled = x <= 2;
      btnNext.disabled = x >= maxScrollLeft;
    }

    if (hasArrows()) {
      btnPrev.addEventListener("click", function () {
        track.scrollBy({ left: -getStep(), behavior: "smooth" });
      });

      btnNext.addEventListener("click", function () {
        track.scrollBy({ left: getStep(), behavior: "smooth" });
      });

      track.addEventListener("scroll", function () {
        window.requestAnimationFrame(updateButtons);
      });

      window.addEventListener("resize", function () {
        window.requestAnimationFrame(updateButtons);
      });

      updateButtons();
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-nhsi]").forEach(init);
  });
})();
